import React, { useState } from 'react';
import useStats from '../utils/useStats';
import { CountryModal } from './CountryModal'
import { Table } from 'rsuite';



function CountryTable() {
    const [isCountryModalOpened, setModalOpen] = useState(false);
    const [countryData, setCountryData] = useState({});
    const { Column, HeaderCell, Cell } = Table;
    const { stats, loading } = useStats('https://coronavirus-19-api.herokuapp.com/countries');

    function openModal(data) {
        setCountryData(data);
        setModalOpen(true)
    }


    return (
        <div>
            <CountryModal data={countryData} close={() => setModalOpen(false)} show={isCountryModalOpened} />
            <Table
                loading={loading}
                virtualized
                bordered
                data={stats}
                height={500}
                onRowClick={openModal}
            >
                <Column width={120} fixed>
                    <HeaderCell>Country</HeaderCell>
                    <Cell className="country-cell" dataKey="country" />
                </Column>
                <Column width={120}>
                    <HeaderCell>Confirmed</HeaderCell>
                    <Cell dataKey="cases" />
                </Column>
                <Column width={120}>
                    <HeaderCell>Today cases</HeaderCell>
                    <Cell dataKey="todayCases" />
                </Column>
                <Column width={120}>
                    <HeaderCell>Deaths</HeaderCell>
                    <Cell dataKey="deaths" />
                </Column>
                <Column width={120}>
                    <HeaderCell>Today deaths</HeaderCell>
                    <Cell dataKey="todayDeaths" />
                </Column>
                <Column width={120}>
                    <HeaderCell>Recovered</HeaderCell>
                    <Cell dataKey="recovered" />
                </Column>
                <Column width={120}>
                    <HeaderCell>Active cases</HeaderCell>
                    <Cell dataKey="active" />
                </Column>
                <Column width={120}>
                    <HeaderCell>Critical</HeaderCell>
                    <Cell dataKey="critical" />
                </Column>
            </Table>
        </div>
    )
}

export default CountryTable;